var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quit-comp",style:({ transform: `scale(${_vm.scale})`, transformOrigin: 'top left' }),on:{"click":_vm.quit}},[_vm._t("default",function(){return [_c('img',{staticClass:"arrow",attrs:{"src":require("../images/icon_arrow_left@2x.png"),"width":_vm.$px(18),"height":_vm.$px(18)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }